export const invenType = [
  {
    key: 'INVENTORY_FEED',
    value: '头条系'
  },
  {
    key: 'INVENTORY_VIDEO_FEED',
    value: '西瓜信息流'
  },
  // {
  //   key: 'INVENTORY_HOTSOON_FEED',
  //   value: '火山信息流'
  // },
  {
    key: 'INVENTORY_AWEME_FEED',
    value: '抖音信息流'
  },
  {
    key: 'INVENTORY_UNION_SLOT',
    value: '穿山甲'
  },
  {
    key: 'UNION_BOUTIQUE_GAME',
    value: '穿山甲精选休闲游戏'
  }
]

export const statusData = [
  {
    id: 0,
    name: '不限（包含已删除）'
  },
  {
    id: 1,
    name: '投放中'
  },
  {
    id: 2,
    name: '已删除'
  },
  {
    id: 3,
    name: '项目超出预算'
  },
  {
    id: 5,
    name: '未到达投放时间'
  },
  {
    id: 6,
    name: '已完成'
  },
  {
    id: 7,
    name: '不在投放时段'
  },
  {
    id: 8,
    name: '新建审核中'
  },
  {
    id: 9,
    name: '修改审核中'
  },
  {
    id: 10,
    name: '已终止'
  },
  {
    id: 11,
    name: '审核不通过'
  },
  {
    id: 12,
    name: '计划超出预算'
  },
  {
    id: 13,
    name: '账户余额不足'
  },
  {
    id: 15,
    name: '已暂停'
  },
  {
    id: 16,
    name: '已被项目暂停'
  },
  {
    id: 21,
    name: '已暂停（配额达限）'
  }
]

export const projectStatusData = [
  {
    id: 2,
    name: '不限（包含已删除）'
  },
  {
    id: 1,
    name: '启用'
  },
  {
    id: 0,
    name: '暂停'
  },
  {
    id: -1,
    name: '删除'
  },
  {
    id: 4,
    name: '项目超出预算'
  },
  {
    id: 6,
    name: '未达投放时间'
  },
  {
    id: 7,
    name: '已完成'
  },
  {
    id: 8,
    name: '不在投放时段'
  }
]
